import React from 'react';
import { useParams } from 'react-router-dom';
import Terminal from '../components/Terminal';

const SessionTerminalPage = () => {
    const { slug } = useParams(); // Extract slug from URL

    return (
        <div>
            <h1>Interactive Terminal for Session: {slug}</h1>
            <p>
                This terminal is connected to the backend WebSocket for session "<strong>{slug}</strong>".
            </p>
            {/* Pass the slug dynamically to the Terminal component */}
            <Terminal sessionSlug={slug} />
        </div>
    );
};

export default SessionTerminalPage;
